
export default function PlanCards() {
  return (
    <section className="py-8 sm:py-12 px-4 sm:px-6">
      <div className="max-w-5xl mx-auto">
        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {/* Plano Start */}
          <div className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6 sm:p-8 relative hover:shadow-xl transition-shadow duration-300">
            <div className="border-t-4 border-gray-300 absolute top-0 left-6 right-6 rounded-t-full"></div>
            
            <div className="flex items-center gap-3 mb-4">
              <h3 className="text-2xl font-bold text-gray-900">Start</h3>
              <span className="px-3 py-1 bg-amber-100 text-amber-700 text-xs font-semibold rounded-full">
                POPULAR
              </span>
            </div>
            
            <p className="text-gray-500 text-sm mb-6">
              Ideal para quem está começando a automatizar o atendimento
            </p>
            
            <div className="flex items-baseline mb-2">
              <span className="text-2xl font-medium text-gray-600">R$</span>
              <span className="text-6xl font-bold text-gray-900 mx-1">197</span>
              <span className="text-gray-500">/mês</span>
            </div>
            <p className="text-gray-400 text-sm mb-8">Cobrado mensalmente no cartão</p>
            
            <a
              href="https://wa.me/5541992584018?text=Olá! Tenho interesse no Plano Start da NeuroAgents."
              target="_blank"
              rel="noopener noreferrer"
              className="w-full bg-gray-900 hover:bg-gray-800 text-white py-4 rounded-xl font-semibold transition-colors flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap mb-8"
            >
              Começar Agora
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-right-line"></i>
              </div>
            </a>
            
            <div>
              <p className="font-semibold text-gray-900 mb-4">O que está incluído:</p>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-accent-green text-lg"></i>
                  </div>
                  <span className="text-gray-600 text-sm">Agente de IA para WhatsApp</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-accent-green text-lg"></i>
                  </div>
                  <span className="text-gray-600 text-sm">Atendimento automático 24/7</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-accent-green text-lg"></i>
                  </div>
                  <span className="text-gray-600 text-sm">Follow-up automático</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-accent-green text-lg"></i>
                  </div>
                  <span className="text-gray-600 text-sm">CRM interno básico</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-accent-green text-lg"></i>
                  </div>
                  <span className="text-gray-600 text-sm">Dashboard de métricas</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-accent-green text-lg"></i>
                  </div>
                  <span className="text-gray-600 text-sm">Organização de contatos</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-accent-green text-lg"></i>
                  </div>
                  <span className="text-gray-600 text-sm">Histórico de atendimento</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-close-line text-gray-300 text-lg"></i>
                  </div>
                  <span className="text-gray-400 text-sm">Instagram e Facebook</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-close-line text-gray-300 text-lg"></i>
                  </div>
                  <span className="text-gray-400 text-sm">Disparos em massa</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Plano Scale */}
          <div className="bg-gradient-to-br from-gray-900 to-black rounded-2xl shadow-2xl p-6 sm:p-8 relative hover:shadow-3xl transition-shadow duration-300 transform md:-translate-y-4">
            <div className="border-t-4 border-primary absolute top-0 left-6 right-6 rounded-t-full"></div>
            <span className="absolute -top-3 right-6 px-4 py-1.5 bg-primary text-white text-xs font-bold rounded-full shadow-lg">
              RECOMENDADO
            </span>
            
            <div className="flex items-center gap-3 mb-4">
              <h3 className="text-2xl font-bold text-white">Scale</h3>
              <span className="px-3 py-1 bg-primary/20 text-primary-light text-xs font-semibold rounded-full">
                COMPLETO
              </span>
            </div>
            
            <p className="text-gray-400 text-sm mb-6">
              Para quem quer escalar o atendimento e maximizar resultados
            </p>
            
            <div className="flex items-baseline mb-2">
              <span className="text-2xl font-medium text-gray-400">R$</span>
              <span className="text-6xl font-bold text-white mx-1">297</span>
              <span className="text-gray-400">/mês</span>
            </div>
            <p className="text-gray-500 text-sm mb-8">Cobrado mensalmente no cartão</p>
            
            <a
              href="https://wa.me/5541992584018?text=Olá! Tenho interesse no Plano Scale da NeuroAgents."
              target="_blank"
              rel="noopener noreferrer"
              className="w-full bg-primary hover:bg-primary-dark text-white py-4 rounded-xl font-semibold transition-colors flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap mb-8 shadow-lg shadow-primary/30"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-rocket-line"></i>
              </div>
              Escalar Agora
            </a>
            
            <div>
              <p className="font-semibold text-white mb-4">Tudo do Start, mais:</p>
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-primary text-lg"></i>
                  </div>
                  <span className="text-gray-300 text-sm">Agente de IA para WhatsApp</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-primary text-lg"></i>
                  </div>
                  <span className="text-gray-300 text-sm">Atendimento automático 24/7</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-primary text-lg"></i>
                  </div>
                  <span className="text-gray-300 text-sm">Follow-up automático</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-primary text-lg"></i>
                  </div>
                  <span className="text-white text-sm font-medium flex items-center gap-2">
                    Integração Instagram
                    <span className="px-2 py-0.5 bg-gradient-to-r from-amber-500 to-orange-500 text-white text-[10px] font-bold rounded">PRO</span>
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-primary text-lg"></i>
                  </div>
                  <span className="text-white text-sm font-medium flex items-center gap-2">
                    Integração Facebook Messenger
                    <span className="px-2 py-0.5 bg-gradient-to-r from-amber-500 to-orange-500 text-white text-[10px] font-bold rounded">PRO</span>
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-primary text-lg"></i>
                  </div>
                  <span className="text-white text-sm font-medium flex items-center gap-2">
                    Disparos em massa
                    <span className="px-2 py-0.5 bg-gradient-to-r from-amber-500 to-orange-500 text-white text-[10px] font-bold rounded">PRO</span>
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-primary text-lg"></i>
                  </div>
                  <span className="text-white text-sm font-medium flex items-center gap-2">
                    Email marketing
                    <span className="px-2 py-0.5 bg-gradient-to-r from-amber-500 to-orange-500 text-white text-[10px] font-bold rounded">PRO</span>
                  </span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-primary text-lg"></i>
                  </div>
                  <span className="text-white text-sm font-medium">CRM avançado</span>
                </li>
                <li className="flex items-start gap-3">
                  <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-check-line text-primary text-lg"></i>
                  </div>
                  <span className="text-white text-sm font-medium">Suporte prioritário via WhatsApp</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
